import {
  MAX_SALARY_ADJUSTMENT_DIGITS,
  SalaryAdjustmentDatabaseRowKey,
} from "./adjustSalary.logic";

interface SalaryAdjustmentPresentation {
  readonly fixedSign?: "+" | "−";
  readonly inputMaxLength: number;
  readonly labelTranslationKey: string;
  readonly placeholderTranslationKey: string;
}

export const salaryAdjustmentPresentation: Record<
  SalaryAdjustmentDatabaseRowKey,
  SalaryAdjustmentPresentation
> = {
  [SalaryAdjustmentDatabaseRowKey.SalaryAdjustment]: {
    inputMaxLength: MAX_SALARY_ADJUSTMENT_DIGITS + 1,
    labelTranslationKey: "Salary.AdjustmentSalary",
    placeholderTranslationKey: "Salary.AdjustmentAmountPlaceholder",
  },
  [SalaryAdjustmentDatabaseRowKey.Benefit]: {
    fixedSign: "+",
    inputMaxLength: MAX_SALARY_ADJUSTMENT_DIGITS,
    labelTranslationKey: "Salary.AdjustmentBenefit",
    placeholderTranslationKey: "Salary.AdjustmentUnsignedAmountPlaceholder",
  },
  [SalaryAdjustmentDatabaseRowKey.WageGarnishment]: {
    fixedSign: "−",
    inputMaxLength: MAX_SALARY_ADJUSTMENT_DIGITS,
    labelTranslationKey: "Salary.AdjustmentWageGarnishment",
    placeholderTranslationKey: "Salary.AdjustmentUnsignedAmountPlaceholder",
  },
};
